import { Form } from 'antd';
import Box from 'components/Box';
import DollarInputPayment from 'components/DollarAmount/DollarInputPayment';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import ActionButtons from '../PaymentTabMenu/components/ActionButtons';
import SectionV2 from '../PaymentTabMenu/components/SectionV2';
import SwitchBtn from '../ServicesSettingV2/SwitchBtn';
import DayOfWeek from './DayOfWeek';
import StaffApply from './StaffApply';
import shopSelectors from 'services/shop/selectors';
import { useEffect } from 'react';
import { getMessageError, IResponseDataBody } from 'services/response';
import toast from 'utils/toast';
import shopApis from 'services/shop/apis';
import { ICleaningFeeResData } from 'services/shop/types/cleaning-fee';
import shopActions from 'services/shop/actions';

const CleaningFeeTab = () => {
  const cleaningFee = shopSelectors.data.cleaningFee();
  const dispatch = useAppDispatch();
  const [form] = Form.useForm<any>();
  const setLoading = useSetLoadingPage();

  useEffect(() => {
    form.setFieldsValue(cleaningFee);
  }, [cleaningFee]);

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      const res: IResponseDataBody<ICleaningFeeResData> = await shopApis.updateCleaningFee(values);
      if (res.data.data) {
        dispatch(shopActions.get.cleaningFee.fetch());
      }
    } catch (error) {
      const msg = getMessageError(error);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <TaxStyled>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ saleTaxPercent: 0, useTaxPercent: 0 }}
      >
        <FormV2Container>
          <Container>
            <Box display="flex" gap="3" alignItems="center">
              <Form.Item noStyle name="enableCleaningFee">
                <SwitchBtn />
              </Form.Item>
              <span className='section-label'>
                Cleaning fee
              </span>
            </Box>
            <Form.Item name="cleaningFee" noStyle>
              <DollarInputPayment />
            </Form.Item>
            <Box display='flex' flexDirection='column' gap='2'>
              <span className='section-label'>
                Select dates without cleaning fee
              </span>
              <Form.Item noStyle name={'dayIgnoreFee'}>
                <DayOfWeek />
              </Form.Item>
            </Box>
            <Form.Item noStyle name={'staffIds'}>
              <StaffApply />
            </Form.Item>
          </Container>
          <ActionButtons />
        </FormV2Container>
      </Form>
    </TaxStyled>
  );
};

export default CleaningFeeTab;

const Container = styled(SectionV2)`
  background-color: #fff;
  border: none;

  .dollar-input-selector {
    border-radius: 4px;
    background: #FFF;
    align-self: stretch;
    padding-left: 10px; 
    padding-right: 10px; 
    .dollar-input-text {
      font-family: Poppins;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
`;
const TaxStyled = styled.div`
  flex-grow: 1;
  border-radius: 5px;
  .ant-input-number-input-wrap {
    height: 100%;
    input {
      color: #1d2129;
      font-size: 1.125rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  background: unset;
`;
const FormV2Container = styled.div`
  background: #fff;
  padding: 16px;
  .ant-input {
      color: #1D2129;
      font-family: Poppins;
      font-size: 24px !important;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
  }
  .ant-form-item-label label {
    color: #1D2129;
    font-family: Poppins;
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

const FormItemStyled = styled(Form.Item)`
  margin: 0;
`;